// Stock ShadCN controls keep text-sm at every size (xs aside).
export const controlTypography = "text-sm font-semibold";

// Tabs and ToggleGroup use exactly the same default track chrome.
export const segmentedTrackClasses =
  "inline-flex w-fit items-stretch justify-center gap-1 rounded-xl bg-muted p-1 text-muted-foreground";

// One focus indicator everywhere: a ring-colored outline offset from the edge.
// outline-solid is needed because outline-none also resets --tw-outline-style.
export const focusRing =
  "outline-none focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-3 focus-visible:outline-ring";
